import { __awaiter } from "tslib";
import { useEffect } from 'react';
import { getIn, useFormikContext } from 'formik';
import { useTranslation } from 'react-i18next';
import { checkVAT, countries } from 'jsvat-next/lib/es6';
import { useAemConfig } from '@as-react/common-components';
import GeneralAPI from '../../api/general/GeneralAPI';
import { I18N_NAMESPACES } from '../../constants/i18nConstants';
import { DELAY } from '../../constants/GeneralConstants';
import { ErrorMessage } from '@as-react/common-types';
export const InvoiceChangeHandler = ({ countryCode, setCompanyNameLocked, setIsAddressRequired, needInvoiceFieldName = 'invoice', vatNumberFieldName = 'vatNumber', companyFieldName = 'companyName', isVatFieldName = 'finance.isVat', isViesVerifiedFieldName = 'finance.isViesVerified', }) => {
    const { defaultRequestParams, servicesEndpoint } = useAemConfig();
    const { t } = useTranslation(I18N_NAMESPACES.account);
    const { values, setFieldValue, setFieldError } = useFormikContext();
    const vatNumber = getIn(values, vatNumberFieldName);
    const companyName = getIn(values, companyFieldName);
    const invoice = getIn(values, needInvoiceFieldName);
    const getCompanyDetailsForVatNumber = (vatCountryCode, vatDigits) => __awaiter(void 0, void 0, void 0, function* () {
        if (!companyName) {
            const data = yield GeneralAPI.getCompanyInformationByVAT(servicesEndpoint, defaultRequestParams, vatCountryCode, vatDigits);
            if (data === null || data === void 0 ? void 0 : data.isVat) {
                setFieldValue(companyFieldName, data.viesResponse.name);
                setFieldValue(isVatFieldName, data.isVat);
                setFieldValue(isViesVerifiedFieldName, data.isViesVerified);
            }
        }
        setCompanyNameLocked(false);
    });
    useEffect(() => {
        let isSubscribed = true;
        const validateVat = () => {
            var _a, _b;
            isSubscribed && setCompanyNameLocked(true);
            const currentCountry = countryCode && countries.find(item => item.codes.includes(countryCode));
            if (!currentCountry) {
                return;
            }
            const vatCheckResult = checkVAT(vatNumber, [currentCountry]);
            if (vatCheckResult.isValid) {
                isSubscribed && setFieldValue(vatNumberFieldName, vatCheckResult.value);
                const vatCountryCode = (_a = vatCheckResult.value) === null || _a === void 0 ? void 0 : _a.slice(0, 2);
                const vatDigits = (_b = vatCheckResult.value) === null || _b === void 0 ? void 0 : _b.slice(2);
                vatCountryCode && vatDigits && getCompanyDetailsForVatNumber(vatCountryCode, vatDigits);
            }
            else {
                setCompanyNameLocked(false);
                setTimeout(() => {
                    isSubscribed && setFieldError(vatNumberFieldName, t(ErrorMessage.INVALID_VAT_NUMBER));
                }, DELAY.DELAY_0);
            }
        };
        if (vatNumber && countryCode) {
            validateVat();
        }
        return () => {
            isSubscribed = false;
        };
    }, [countryCode, vatNumber]);
    useEffect(() => {
        setIsAddressRequired(invoice);
    }, [invoice]);
    return null;
};
